module.exports = __webpack_public_path__ + "img/preset3.734d6e95.png";